module.exports = __webpack_public_path__ + "img/product-ketang-qt-07.79e9e028.png";